import { api } from './api';

class VendorRegistrationService {
    // Get all vendor registrations with optional filters
    async getVendorRegistrations(filters = {}) {
        const params = new URLSearchParams();
        
        if (filters.vendor_id) params.append('vendor_id', filters.vendor_id);
        if (filters.entity_type) params.append('entity_type', filters.entity_type);
        if (filters.approval_status) params.append('approval_status', filters.approval_status);
        if (filters.registration_type) params.append('registration_type', filters.registration_type);
        if (filters.limit) params.append('limit', filters.limit);
        
        const queryString = params.toString();
        const endpoint = `/api/vendor-registrations/${queryString ? `?${queryString}` : ''}`;
        
        return api.get(endpoint);
    }

    // Get vendor registration by ID
    async getVendorRegistrationById(registrationId) {
        return api.get(`/api/vendor-registrations/${registrationId}`);
    }

    // Get registrations for current user
    async getMyRegistrations(approvalStatus = null) {
        const params = new URLSearchParams();
        if (approvalStatus) params.append('approval_status', approvalStatus);
        
        const queryString = params.toString();
        const endpoint = `/api/vendor-registrations/my-registrations${queryString ? `?${queryString}` : ''}`;
        
        return api.get(endpoint);
    }

    // Update vendor registration
    async updateVendorRegistration(registrationId, updateData) {
        return api.put(`/api/vendor-registrations/${registrationId}`, updateData);
    }

    // Submit vendor registration for approval
    async submitVendorRegistration(registrationId) {
        return api.put(`/api/vendor-registrations/${registrationId}/submit`);
    }

    // Approve vendor registration
    async approveVendorRegistration(registrationId) {
        return api.put(`/api/vendor-registrations/${registrationId}/approve`);
    }

    // Reject vendor registration
    async rejectVendorRegistration(registrationId, rejectionReason) {
        return api.put(`/api/vendor-registrations/${registrationId}/reject`, {
            rejection_reason: rejectionReason
        });
    }

    // Delete vendor registration
    async deleteVendorRegistration(registrationId) {
        return api.delete(`/api/vendor-registrations/${registrationId}`);
    }

    // Get service types for dropdown
    async getServiceTypes() {
        return api.get('/api/vendor-registrations/service-types');
    }

    // Get service subtypes for a specific service type
    async getServiceSubtypes(serviceTypeCode) {
        return api.get(`/api/vendor-registrations/service-types/${serviceTypeCode}/subtypes`);
    }
}

export const vendorRegistrationService = new VendorRegistrationService(); 